<template>
  <v-container fluid>
    <div>
      <h2>{{$tc('audit_log', 2)}}</h2>
      <audit-log/>
    </div>
  </v-container>
</template>
<script>

import AuditLog from '@/components/audit-log/AuditLog'
import BrowserUtilitiesMixin from '@/components/mixins/BrowserUtilitiesMixin'

export default {
  name: 'AuditLogIndex',
  components: {
    AuditLog
  },
  mixins: [
    BrowserUtilitiesMixin
  ],
  mounted () {
    this.updateBrowserTitle(this.$tc('audit_log', 2))
  }
}
</script>
